import SchoolTable from './SchoolTable';

export default SchoolTable;
